import { safeFetch } from "@/lib/fetch";
import environment, { apiUrls } from "@/modules/environment";

export function fetchCurrentUser(sessionToken: string): Promise<User> {
  return safeFetch(`${apiUrls.parseUrl}/users/me`, {
    headers: {
      "X-Parse-Application-Id": environment.appName,
      "X-Parse-Session-Token": sessionToken
    }
  });
}
